import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './services/api.service';
import { UtilitiesService } from './services/utilities.service';
import { CommonService } from './services/common.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'PHYSIO LIFE CLINIC';

  constructor(
    private router: Router,
    public utility: UtilitiesService,
    public api: ApiService,
    public common: CommonService
  ) { }

  ngOnInit(): void {
    //this.common.getOffer();
  }

  onLogout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('is_valid');
    localStorage.removeItem('role');

    this.router.navigate(['login']);
  }
}
